import React from 'react';
import './cover.scss';
import cover_ka from '../../images/congress_cover_ka.png';
import cover_en from '../../images/congress_cover_en.png';
import cover_ru from '../../images/congress_cover_ru.png';

class Cover extends React.Component {

  render() {
    const covers = {
      ka: cover_ka,
      en: cover_en,
      ru: cover_ru
    };


    return (
      <div className="component cover">
        <img src={covers[this.props.commonProps.lang]} alt="cover" />
      </div>
    );
  }

}

export default Cover;
